var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.latitude == 0 && _vm.longitude == 0)?_c('div',[_c('h4',{staticClass:"danger"},[_vm._v("Essa ocorrência não possui localização")])]):_vm._e(),_c('base-map',{attrs:{"apiKey":_vm.apiKey,"pin":_vm.pin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }